import { combineReducers } from 'redux'
import { routerReducer } from 'react-router-redux'

import form from './form'
import campaign from './campaign'
import contributors from './contributors'
import txns from './txns'
import user_txns from './user_txns'
import send_iframe from './send_iframe'
import coming_soon_dialog from './coming_soon_dialog'
import nop from './nop'
import funding_sources from './funding_sources'
import current_user from './current_user'
import server from './server'

export const reducer = combineReducers({
  routing: routerReducer,
  form,
  campaign,
  contributors,
  txns,
  user_txns,
  send_iframe,
  coming_soon_dialog,
  funding_sources,
  current_user,
  server,
  // This is just data passed from the server. We use the nop reducer
  // (which does nothing) to prevent redux's unrecognized keys warning
  locality: nop,
  login_info: nop,
  flags: nop,
  device_info: nop,
  links: nop,
  user_config: nop,
  features: nop,
  group_features: nop,
  country: nop,
  social: nop,
  mobile_app: nop,
  // TODO we should consider putting all of these in an 'experiments' reducer
  can_pledge: nop,
  rampdown: nop,
  can_guest: nop,
  isFFEligible: nop,
  deployEnv: nop,
  preloadSendValues: nop,
  isEnrolledInCFPBRamp: nop,
})
